import React from 'react';
import { useSelector } from 'react-redux';
import FilterDark from 'src/assets/images/FilterDark.svg';
import FilterLight from 'src/assets/images/FilterLight.svg';
import FilterActiveDark from 'src/assets/images/FilterActiveDark.svg';
import FilterActiveLight from 'src/assets/images/FilterActiveLightNew.svg';
import {
    FilterIconContainer,
    FilterIcon,
} from './ConsignedFilter.styled';
import FilterContainer from './FilterContainer';

/**
 * ConsignedFilter (SCAFFOLD)
 * Self-contained filter icon + popup shell for the Consigned inventory page,
 * modeled on the Field Inventory Dashboard filter. Rendered at the far right
 * of the "Inventory" header.
 * TODO(team): populate FilterBody with the consigned filter sections and wire
 * Reset / Apply to the API query params.
 */
const ConsignedFilter = ({
    isOpen = false,
    setIsOpen = () => {},
}) => {
    const {consignedAppliedFilters, defaultTerritory} = useSelector(
            (state) => state.consignedInventoryReducer
        );
    const {districtUID, territoryUID, accountNumber, brand} = consignedAppliedFilters || {};
    const hasMeaningfulBrand = brand?.length > 0 && !brand.every(code => code === 'All');
    // 'All' selections and the default territory don't count as an active filter
    const isFilterApplied =
        (!!districtUID && districtUID !== 'All') ||
        (!!territoryUID && territoryUID !== 'All' && territoryUID !== defaultTerritory) ||
        (!!accountNumber && accountNumber !== 'All') ||
        hasMeaningfulBrand;
    // Reset must stay available when the applied territory differs from the default, e.g. 'All'
    const isResettable = isFilterApplied || (!!territoryUID && territoryUID !== (defaultTerritory || 'All'));
    const toggleFilter = () => setIsOpen((prev) => !prev);

    return (
        <FilterIconContainer id="consigned-filter-icon-container">
            <FilterIcon
                id="consigned-filter-icon"
                deskPath={isFilterApplied ? FilterActiveLight : FilterLight}
                mobilePath={isFilterApplied ? FilterActiveDark : FilterDark}
                onClick={toggleFilter}
            />
            {isOpen && (
                <FilterContainer setIsOpen={setIsOpen} isFilterApplied={isResettable}/>
            )}
        </FilterIconContainer>
    );
};

export default ConsignedFilter;
